import { StyledHtmlText, StyledPublicFontFamily } from '@framework/engine';
import { Typography } from 'antd';
import DOMPurify from 'dompurify';
import React from 'react';
import styled from 'styled-components';
import { FocusableHeader } from './FocusableHeader';
const { Title, Paragraph, Text } = Typography;

const TitleWrapper = styled.div`
  margin-bottom: 12px;
  margin-top: 20px;
`;
const StyledTitleDescription = styled(Title)`
  &&& {
    ${StyledPublicFontFamily}
    font-size: 16px;
    line-height: 1.5;
    font-weight: 400;
    letter-spacing: -0.015em;
    margin-top: 0;
    margin-bottom: 6px;
    color: inherit;
  }
`;

export interface SectionTitleProps {
  nome?: string | null;
  descrizione?: string | null;
  codice?: string | null;
  /*  Indica che il titolo deve essere mostrato 
  con il colore dell'indagine */
  accentColor?: boolean;
}

/**
 * Titolo di una sezione della sezione
 * includendo il codice, il nome e la descrizione
 */
export function SectionTitle(props: SectionTitleProps) {
  const { nome, descrizione } = props;
  if (!nome && !descrizione) return null;

  return (
    <TitleWrapper>
      <FocusableHeader {...props} />
      {descrizione && (
        <StyledTitleDescription as="div">
          <StyledHtmlText
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(descrizione),
            }}
          />
        </StyledTitleDescription>
      )}
    </TitleWrapper>
  );
}
